





































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import MapTracking from '@/components/MapTracking.vue'
import FilterTracking from '@/components/filters/FilterTracking.vue'
import TrackingRequest from '@/model/request/TrackingRequest'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import PosicaoMotorista from '@/model/resource/PosicaoMotorista'
import {$, PageCollection} from 'simpli-web-sdk'
import FilterToggle from '@/components/FilterToggle.vue'
import moment from 'moment'

const metaInfo = () => ({
  title: $.t('view.tracking.title'),
})

@Component({
  metaInfo,
  components: {FilterTracking, MapTracking, FilterToggle},
})
export default class TrackingView extends Mixins(MixinFilter) {
  @Action('sentinel/onUpdate') onUpdate!: Function
  AppConfig = AppConfig

  filter = new TrackingRequest()
  collection = new PageCollection(PosicaoMotorista, this.filter)
  collectionMap = new PageCollection(PosicaoMotorista, this.filter, null, null)
  model: PosicaoMotorista | null = null

  beforeDestroy() {
    this.onUpdate(() => {/**/})
  }

  @Watch('filter', {deep: true})
  resetEvent() {
    this.model = null
  }

  async populate() {
    await this.query()
    await this.$await.run(() => this.collectionMap.search(), 'queryMap')

    if (this.filter.updateAutomatically === true) {
      this.onUpdate(() => {
        this.query()
        this.$await.run(() => this.collectionMap.search(), 'queryMap')
      })
    } else {
      this.onUpdate(() => {/**/})
    }
  }

  getIconColor(item: PosicaoMotorista) {
    if (item.customTrack) {
      return 'custom'
    } else if (item.carga.dataPrevisao && moment().isAfter(moment(item.carga.dataPrevisao))) {
      return 'late'
    }

    return item.carga.dataCheckIn ? 'checkin' : 'trajeto'
  }

  getIconMessage(item: PosicaoMotorista) {
    if (item.customTrack) {
      return this.$t('view.tracking.checkin.custom')
    }
    return item.carga.dataCheckIn ? this.$t('view.tracking.checkin.checkin') : this.$t('view.tracking.checkin.trajeto')
  }

  openInGoogleMaps(position: PosicaoMotorista) {
    const url = `https://www.google.com.br/maps/search/?api=1&query=${position.latitude},${position.longitude}`
    window.open(url, '_blank')
  }
}
